import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { FeaturedLinkedInPost } from "@/config/linkedin";

// Public read of published homepage LinkedIn cards (max 3, newest first).
export const getPublishedLinkedInCards = createServerFn({ method: "GET" }).handler(
  async (): Promise<FeaturedLinkedInPost[]> => {
    try {
      const sb = createClient(process.env.SUPABASE_URL!, process.env.SUPABASE_PUBLISHABLE_KEY!, {
        auth: { persistSession: false },
      });
      const { data } = await sb
        .from("linkedin_cards")
        .select("category,title,summary,post_date,image,image_alt,linkedin_url,internal_url")
        .eq("published", true)
        .order("post_date", { ascending: false })
        .limit(3);
      return (data ?? []).map((r) => ({
        category: r.category,
        title: r.title,
        summary: r.summary,
        date: r.post_date,
        image: r.image,
        imageAlt: r.image_alt ?? undefined,
        linkedinUrl: r.linkedin_url,
        internalUrl: r.internal_url ?? undefined,
      }));
    } catch {
      return [];
    }
  },
);
